// import { loginByUsername, logout, getUserInfo } from '@/api/login'
// import { getToken, setToken, removeToken } from '@/tools/auth'
import { getUserDetail } from '@/tools/auth';
import qiankunStore from '@/qiankun/store'; // qiankun

export const baseMenus = [
  { label: '首页', name: 'home', weight: 1 },
  { label: '下载中心', name: 'downloadList', weight: 2 }
];
export let masterMenus = [
  {
    label: '结算中心',
    name: 'v3-settlement-center',
    weight: 2.5,
    showKey: 'showSettlementCenter'
  },
  { label: '账号管理', name: 'accountManagement', weight: 3 },
  { label: '完税证明', name: 'dutypaidProofList', weight: 6 },
  { label: '发票管理', name: 'invoiceList', weight: 7 }
];
export const asyncMenus = [
  { label: '电子合同管理', name: 'contractList', weight: 4 },
  { label: '推广管理', name: 'zoneList', weight: 5 },
  { label: '任务进度', name: 'v3-persontask-progress-list', weight: 8 },
  {
    label: '招商管理',
    name: 'zs-manage',
    weight: 8,
    showKey: 'showZsManager'
  },
  {
    label: '材料下载',
    name: 'material-download',
    weight: 9
  },
  {
    label: '提交材料管理',
    name: 'digtal-storage',
    weight: 10,
    showKey: 'showSubMaterial'
  }
];

const user = {
  state: {
    user: '',
    status: '',
    code: '',
    // token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    },
    userInfo: getUserDetail()
  },
  getters: {
    userInfo: state => state.userInfo,
    // 是否是主账号！！！
    isMaster: state => {
      try {
        return +state.userInfo['user']['isMainAccountNumber'] === 1;
      } catch (error) {
        return false;
      }
    },
    menus: (state, getters) => {
      if (getters.isMaster) {
        return [
          ...baseMenus,
          ...masterMenus.filter(i => {
            if ('showKey' in i) {
              return ((state.userInfo || {}).user || {})[i.showKey];
            }
            return true;
          }),
          ...asyncMenus.filter(i => {
            if ('showKey' in i) {
              return ((state.userInfo || {}).user || {})[i.showKey];
            }
            return true;
          })
        ].sort((a, b) => {
          if (a.weight < b.weight) {
            return -1;
          }
        });
      }
      let acceptMenus = [];
      const remoteMenus = state.userInfo['limitsOfAuthorityMenuList'];
      if (remoteMenus.length) {
        remoteMenus.forEach(i => {
          let menu = asyncMenus.find(j => {
            return j.label === i.menuName;
          });
          if (menu) {
            acceptMenus.push(menu);
          }
        });
      }
      return [...baseMenus, ...acceptMenus].sort((a, b) => {
        if (a.weight < b.weight) {
          return -1;
        }
      });
    }
  },
  mutations: {
    SET_CODE: (state, code) => {
      state.code = code;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
      qiankunStore.setGlobalState({ token }); // qiankun: 同步到子服务中
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction;
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting;
    },
    SET_STATUS: (state, status) => {
      state.status = status;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_INFO: (state, payload) => {
      state.userInfo = payload;
      qiankunStore.setGlobalState({
        isMaster: payload.user.isMainAccountNumber
      }); // qiankun: 同步到子服务中
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password)
          .then(response => {
            const data = response.data;
            const token = data.token;
            commit('SET_TOKEN', token);
            // setToken(token);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token)
          .then(response => {
            if (!response.data) {
              // 由于mockjs 不支持自定义状态码只能这样hack
              reject('error');
            }
            const data = response.data;
            commit('SET_ROLES', data.roles);
            commit('SET_NAME', data.name);
            commit('SET_AVATAR', data.avatar);
            commit('SET_INTRODUCTION', data.introduction);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('SET_TOKEN', '');
            commit('SET_ROLES', []);
            removeToken();
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        removeToken();
        resolve();
      });
    },

    // 动态修改权限
    ChangeRoles({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role);
        // setToken(role);
        getUserInfo(role).then(response => {
          const data = response.data;
          commit('SET_ROLES', data.roles);
          commit('SET_NAME', data.name);
          commit('SET_AVATAR', data.avatar);
          commit('SET_INTRODUCTION', data.introduction);
          resolve();
        });
      });
    }
  }
};

export default user;
